<ng-container *transloco="let t">
  <div class="pt-32-15 pb-300-100">
    <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>

    <div class="section d-inline-flex align-items-center justify-content-center gap-2 mb-2">
      <div class="d-inline-flex align-items-center justify-content-center gap-1">
        <p class="fw-600 fs-18 counter-number">{{upcomingEvents.length ?? 0}}</p>
        <p class="fw-500 fs-11 color-slate-600 text-uppercase" style="margin-top: 2px;">{{t('event.item.type.upcoming')}}</p>
      </div>
      <div class="divider-vertical"></div>
      <div class="d-inline-flex align-items-center justify-content-center gap-1">
        <p class="fw-600 fs-18 counter-number">{{completedEvents.length ?? 0}}</p>
        <p class="fw-500 fs-11 color-slate-600 text-uppercase" style="margin-top: 2px;">{{t('event.item.type.finished')}}</p>
      </div>
    </div>

    @if (!activeEventStatus || activeEventStatus === EventStatus.ACTIVE) {
    <div>
      <p class="fs-16 fw-600 color-slate-800 mt-3 mb-3">{{ t('league.events.to.go') | uppercase }}</p>
        @if ((upcomingEvents.length ?? 0) > 0) {
          <div class="row">
          @for (event of upcomingEvents; track event.id) {
              <div class="mb-3 event-item" [@listState]>
                        <app-event-grid-item [eventItem]="event"
                                       [layout]="isMobile ? CalendarViewType.GRID : CalendarViewType.LIST"
                                       (onRightButtonClickCallback)="goToEventDetailsPage(event)"
                                       [isLeagueEvent]="true"
                                       [showRegistrationCloses]="leagueEvents?.nextRound?.id === event.id"
                                       [hideShadow]="true"
                                       [showActionButton]="navigateEventIds.has(event.id!)"
                                       [hasFavorite]="navigateEventIds.has(event.id!)"
                                       [showCompetitorCount]="navigateEventIds.has(event.id!)"
                                       [languages]="languages"/>
                      </div>
          }
        </div>
        } @else {
          <app-empty-state/>
      }
      </div>
    }

    @if (!activeEventStatus || activeEventStatus === EventStatus.FINISHED) {
    <div>
      <p class="fs-16 fw-600 color-slate-800 mb-3 mt-2">{{ t('event.calendar.finished.events') | uppercase }}</p>
        @if ((completedEvents.length ?? 0) > 0) {
          <div class="row">
            @for (event of completedEvents; track event.id) {
              <div class="mb-3" [@listState]>
                         <app-event-grid-item [eventItem]="event"
                                       [layout]="isMobile ? CalendarViewType.GRID : CalendarViewType.LIST"
                                       (onRightButtonClickCallback)="goToEventDetailsPage(event)"
                                       [isLeagueEvent]="true"
                                       [hideShadow]="true"
                                       [showActionButton]="navigateEventIds.has(event.id!)"
                                       [hasFavorite]="navigateEventIds.has(event.id!)"
                                       [showCompetitorCount]="navigateEventIds.has(event.id!)"
                                       [languages]="languages"/>
                        </div>
          }
        </div>
        } @else {
          <app-empty-state/>
        }
       </div>
      }
    </div>

    <ng-template #searchFrom>
      @if (leagueEvents?.events?.length || leagueEvents?.templateEvents?.length) {
        <app-filter-panel [groups]="filterGroups"
                      (filterChange)="onFilterChange($event)"
                      [showFilterChips]="false"/>
    }
  </ng-template>

</ng-container>